export default "__VITE_ASSET__DhV9XVHc__"